<div
  class="container-login d-flex flex-column align-items-stretch gap-1 p-3 p-sm-3 pt-sm-2 pb-sm-0"
>
  <div class="d-flex align-items-center">
    <div class="col d-flex justify-content-start">
      <img
        src="../../../../assets/img/common/login-montra-logo.svg"
        class="logo-left"
        alt="Montra One"
      />
    </div>
    <div class="col d-flex justify-content-end">
      <img
        src="../../../../assets/img/common/montra-electric.svg"
        class="logo-right"
        alt="Montra Electric"
      />
    </div>
  </div>
  <div class="row flex-grow-1 me-5" *ngIf="showMainContent" @fadeSlideIn>
    <div
      class="col-lg-7 d-flex flex-column justify-content-start align-items-center text-section"
    >
      <div class="heading-1">Electrifying your drive</div>
      <div class="heading-2">Maximizing your savings</div>
      <div class="heading-3">Every Mile, Every Vehicle</div>
    </div>
    <div
      class="col-lg-5 d-flex justify-content-end align-items-baseline main-container"
      [ngClass]="{ 'with-captcha': isEnableCaptcha }"
    >
      <div class="form-container">
        <h3 class="form-head">Sign In</h3>
        <h6 class="form-sub-head">Please enter your details</h6>
        <form
          *ngIf="loginForm"
          class="form-signin"
          [formGroup]="loginForm"
          (ngSubmit)="signIn()"
          autocomplete="off"
        >
          @for (msg of messages; track $index) {
            <p-message [severity]="$any(msg.severity)" [closable]="true">{{
              msg.summary
            }}</p-message>
          }
          <div class="input-1">
            <input
              type="email"
              id="inputEmail"
              name="useremail"
              pInputText
              formControlName="useremail"
              class="form-control w-100"
              placeholder="Email address"
              [ngClass]="{
                'ng-invalid ng-dirty':
                  loginForm.get('useremail')?.invalid &&
                  loginForm.get('useremail')?.touched,
              }"
              autocomplete="username"
            />
            <small
              class="p-error block"
              *ngIf="
                loginForm.get('useremail')?.hasError('required') &&
                loginForm.get('useremail')?.touched
              "
              >Email is required.</small
            >
          </div>
          <div class="input-2">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="inputPassword"
              name="userpassword"
              formControlName="userpassword"
              class="form-control w-100"
              placeholder="Password"
              pInputText
              [ngClass]="{
                'ng-invalid ng-dirty':
                  loginForm.get('userpassword')?.invalid &&
                  loginForm.get('userpassword')?.touched,
              }"
            />
            <button
              type="button"
              class="eye-icon"
              *ngIf="!showPassword"
              (click)="onChangeVisiblePassword()"
            >
              <svg width="20" height="20">
                <use
                  [attr.xlink:href]="svgPath + 'sprite.svg#' + 'eye-on'"
                ></use>
              </svg>
            </button>
            <button
              type="button"
              class="eye-icon"
              *ngIf="showPassword"
              (click)="onChangeVisiblePassword()"
            >
              <svg width="20" height="20">
                <use
                  [attr.xlink:href]="svgPath + 'sprite.svg#' + 'eye-off'"
                ></use>
              </svg>
            </button>
            <small
              class="p-error block"
              *ngIf="
                loginForm.get('userpassword')?.hasError('required') &&
                loginForm.get('userpassword')?.touched
              "
              >Password is required.</small
            >
          </div>
          <div class="input-captcha" *ngIf="isEnableCaptcha">
            <app-google-recaptcha
              id="recaptcha"
              formControlName="captcha"
              [siteKey]="siteKey"
              [theme]="'light'"
              [size]="'normal'"
            >
            </app-google-recaptcha>

            <div
              *ngIf="
                loginForm.get('captcha')?.hasError('required') && submitted
              "
            >
              <small class="p-error block"> Captcha is required </small>
            </div>
          </div>

          <div class="input-3 mt-3 d-flex justify-content-between">
            <div id="remember" class="checkbox">
              <label class="check-box-label">
                <input
                  type="checkbox"
                  value="remember-me"
                  formControlName="rememberMe"
                />
                Remember me
              </label>
            </div>
            <a routerLink="/verify-email" class="forgot-password">
              Forgot Password
            </a>
          </div>
          <div class="tnc mt-3">
            <p>
              By logging in you agree to our
              <a
                (click)="openPrivacy()"
                (keydown.enter)="openPrivacy()"
                tabindex="0"
                >Privacy Policy
              </a>
            </p>
          </div>
          <button class="button-submit" [disabled]="loading" type="submit">
            {{ loading ? 'Loading...' : 'Sign in' }}
          </button>
          <div class="or-division">
            <svg width="244" height="17">
              <use
                [attr.xlink:href]="svgPath + 'sprite.svg#' + 'or-division'"
              ></use>
            </svg>
          </div>
          <button
            class="microsoft-btn mt-3"
            type="button"
            (click)="loginWithMicrosoft()"
          >
            <span class="microsoft-txt"> Continue with Murugappa SSO </span>
          </button>
          <button class="saving-btn mt-3" type="button" (click)="showDialog()">
            <svg class="saving-svg" width="20" height="20">
              <use
                [attr.xlink:href]="svgPath + 'sprite.svg#' + 'savingsInfo'"
              ></use>
            </svg>
            <span class="saving-txt"> View Savings </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="visible"
  (onHide)="onDialogHide()"
  [modal]="true"
  [style]="{ width: '80vw' }"
  [contentStyle]="{
    'max-height': '90vh',
    overflow: 'auto',
    'border-radius': '24px',
    background: 'rgba(150, 150, 150, 0.55)',
    'backdrop-filter': 'blur(12px)',
    padding: '12px',
  }"
  [closable]="true"
  styleClass="dialog-no-header"
  class="ev-saving-dialog"
>
  <app-ev-savings-dialog></app-ev-savings-dialog>
</p-dialog>

<div *ngIf="loadingService.loading$ | async">
  <app-spinner [fullSpinner]="true"></app-spinner>
</div>
<p-dialog
  header="Header"
  [(visible)]="showConsent"
  [draggable]="false"
  [modal]="true"
  [style]="{ width: '70vw' }"
  class="consent-dialog"
  [closable]="false"
>
  <ng-template #header>
    <div class="table-heading">Customer Consent 1'M Telematics Device</div>
  </ng-template>
  <div class="consent-content" *ngIf="consentData">
    <app-consent [consentData]="consentData"></app-consent>
  </div>
  <ng-template #footer>
    <div class="footer-wrapper">
      <div class="footer-checkbox">
        <label class="check-box-label">
          <input
            type="checkbox"
            value="agreeCheckBox"
            [(ngModel)]="agreeCheckBox"
          />
          I agree to the installation of the 1’M Telematics Device and
          associated data processing.</label
        >
      </div>
      <button
        class="agree-btn"
        type="button"
        [class.loading]="isAgreeLoading"
        [ngClass]="!agreeCheckBox ? 'pointers-none' : ''"
        [disabled]="!agreeCheckBox || isAgreeLoading"
        (click)="onAgree()"
      >
        {{ isAgreeLoading ? 'Loading...' : 'Agree' }}
      </button>
    </div>
  </ng-template>
</p-dialog>
